module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [(_vm.showLogo) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBack) ? _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('span', {
    staticClass: "close-icon",
    class: {
      'open': _vm.menuStatus
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-31983212!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 32
// module chunks = 1